<template>
  <div class="travel-summary card">
    <div class="card-header text-center">
      <h2 class="card-title">{{ summary.travelCarrier }}</h2>
      <h1 class="card-title">{{ summary.travelCarrierID }}</h1>
    </div>
    <div class="card-body" :style="backgroundImgConfig()">
      <div class="row justify-content-between">
        <div class="travel-deprature col text-left">
          <div class="travel-port-code">{{ summary.departPortCode }}</div>
          <div class="travel-port-country">
            <div class="travel-port-name">{{ summary.departPortName }}</div>
            <div class="travel-country">{{ summary.departCountry }}</div>
          </div>
          <div class="travel-date-time">
            <div class="travel-time">{{ summary.departTime }}</div>
            <div class="travel-date">{{ summary.departDate }}</div>
          </div>
        </div>
        <div class="travel-arrival col text-right">
          <div class="travel-port-code">{{ summary.arrivePortCode }}</div>
          <div class="travel-port-country">
            <div class="travel-port-name">{{ summary.arrivePortName }}</div>
            <div class="travel-country">{{ summary.arriveCountry }}</div>
          </div>
          <div class="travel-date-time">
            <div class="travel-time">{{ summary.arriveTime }}</div>
            <div class="travel-date">{{ summary.arriveDate }}</div>
          </div>
        </div>
      </div>
      <div class="row justify-content-start">
        <div class="traveler-count col"><strong>TRAVELER COUNT: </strong>{{ summary.travelerCount }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppTravelSummary',
  props: {
    summary: { type: Object, required: true },
    backgroundImg: String
  },

  methods: {
    backgroundImgConfig() {
      if (!this.backgroundImg) return null;

      return {
        'background-image': 'url(' + require(`@/assets/img/${this.backgroundImg}`) + ')',
        'background-repeat': 'no-repeat',
        'background-position': 'center'
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.travel-summary.card {
  font-family: 'IBM Plex Mono';
  box-shadow: 0px 2px 4px 0px rgba(32, 32, 32, 0.5);
  border: none;
  border-radius: 3px;
  overflow: hidden;
}

.card-header {
  background-color: #002049;
}

.card-header h1.card-title {
  font-size: 36px;
  margin-bottom: 0;
}
.card-header h2.card-title {
  font-size: 28px !important;
}
.card-header .card-title {
  font-weight: 600;
  color: white;
}

.card-body {
  padding: 1rem 3rem 3rem 3rem;
}

.card-body .travel-port-code {
  font-size: 36px;
  font-weight: 900;
  margin-bottom: 0.25rem;
}

.card-body .travel-port-country {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 0.75rem;
}

.card-body .travel-port-name,
.card-body .travel-port-country {
  text-transform: capitalize;
}

.card-body .travel-date-time {
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 1.5rem;
}

.card-body .traveler-count strong {
  font-weight: 800;
}
</style>
